import React from "react";
import { useImageSelector } from "../contexts/ImageSelectorContext";

const ImagePreview = ({ image, index }) => {
  const { removeImage } = useImageSelector();

  return (
    <div
      style={{
        display: "inline-block",
        margin: "5px",
        position: "relative",
        borderRadius: "8px",
        overflow: "hidden",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
      }}
    >
      {/* Image preview */}
      <img
        src={image}
        alt={`Preview ${index}`}
        style={{ width: "100px", height: "100px", objectFit: "cover" }}
      />
      {/* Close button to remove the image */}
      <button
        onClick={() => removeImage(index)}
        style={{
          position: "absolute",
          top: "5px",
          right: "5px",
          backgroundColor: "#ff4444",
          border: "none",
          color: "white",
          borderRadius: "50%",
          width: "20px",
          height: "20px",
          fontSize: "14px",
          cursor: "pointer",
        }}
      >
        &times;
      </button>
    </div>
  );
};

export default ImagePreview;
